import {action} from 'mobx';

import {EXPIRES_IN, EXPIRES_PENDING, EXPIRE_TIME} from '../../../constants/storeConstants';
import {STATE_FULFILLED, STATE_PENDING, STATE_REJECTED} from '../../../constants/asyncConstants';
import serverApi from '../../../utils/serverApi';
import ApiBaseStore from '../common/apiBaseStore';

/**
 * ApiUnsplashPhotoTrackStore
 */
class ApiUnsplashPhotoTrackStore extends ApiBaseStore {
  /**
   * Track unsplash photo use
   *
   * @param {string} downloadLocation
   */
  @action makeRequest(downloadLocation) {
    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.unsplashPhotoTrack(downloadLocation)
      .then(action('unsplashPhotoTrackSuccess', (res) => {
        this.state = STATE_FULFILLED;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;
        this.data = res;
        this.error = null;
      })).catch(action('unsplashPhotoTrackError', (unsplashPhotoTrackError) => {
        this.state = STATE_REJECTED;
        this[EXPIRE_TIME] = null;
        this.data = null;
        this.error = unsplashPhotoTrackError;
      }));
  }
}

export default new ApiUnsplashPhotoTrackStore();
